import React, {Component} from "react";

export class StatusDot extends Component<any> {
    render() {
        return <i className={"fas fa-circle align-middle " + (this.props.status ? "green-dot" : "red-dot")}/>;
    }
}
